import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ChatSupportBtn from "./ChatSupportBtn";
import moment from "moment";
import { logout } from "./Utility";
import customFetch from "./apicall/api";
import _ from "lodash";

class Disbursement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disbdata: [],
      disbdata_bkp: [],
      isSpin: false,
      isView: false,
      loan_documentation_id: "",
      loan_id: "",
      disbdate: "",
      partneref: "",
      loan_detail: [],
      isLoandetail: false,
      isNetoff: false,
      netoffData: [],
      netoffSummary: null,
      netoffRemark: "",
      isSyncing: false,
      lastSyncedAt: null,
    };
    this.handlesubmit = this.handlesubmit.bind(this);
    this.saveCMSData = this.saveCMSData.bind(this);
    this.modalRef = React.createRef();
    this.closeErrPopup = this.closeErrPopup.bind(this);
    this.loadDisburseCase = this.loadDisburseCase.bind(this);
    this.debouncedUpdateNetoffAPI = _.debounce(() => {
      if (this.isAPICalling) {
        this.isDirtyDuringCall = true;
      } else {
        this.callNetoffAPI();
      }
    }, 750);
  }
  componentDidMount() {
    this.getdisbursecase();
  }

  loadDisburseCase() {
    this.state.isErrOpen = false;
    this.getdisbursecase();
  }

  closeErrPopup() {
    this.setState({
      isErrOpen: false,
    });
  }

  getdisbursecase() {
    const { api_token, household_id } =
      (this.props.location && this.props.location.state) || {};
    this.setState({ isSpin: true });
    // AT-2143 | AT-2179 | Ankur Makavana | 12-07-2023 | conver post method to get method

    customFetch(process.env.REACT_APP_URL + "/get/disbursement/cases", {
      method: "GET",
      headers: { "api-token": api_token },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        // console.log(json);
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          localStorage.clear();
          this.props.history.push("/");
        }
        this.setState({
          disbdata: json,
          disbdata_bkp: json,
          isSpin: false,
        });
      })
      .catch((error) => console.log("error", error));
  }
  showpopup(loan_id, loan_documentation_id) {
    this.setState({
      loan_id: loan_id,
      loan_documentation_id: loan_documentation_id,
      isView: true,
      disbdate: "",
      partneref: "",
      isErrOpen: false,
      api_error_message: "",
      sendcase: "",
      isSend: false,
    });
  }

  netOffPopup(loan_id, ref_doc_id, loan_documentation_id) {
    this.setState({
      isNetoff: true,
      loan_id: loan_id,
      loan_documentation_id: loan_documentation_id,
      isSpin: true,
      ovdChanges: "",
      bounceCharges: "",
      p_bal: "",
      int_due: "",
      netoffData: [],
      netoffSummary: null,
      netoffRemark: "",
      isSyncing: false,
      lastSyncedAt: null,
    });

    const { api_token } =
      (this.props.location && this.props.location.state) || {};

    const data = {
      loan_documentation_id: loan_documentation_id,
      adjustments: [], // initial fetch with no edits
    };

    const encodedPayload = Buffer.from(JSON.stringify(data)).toString("base64");

    customFetch(
      `${process.env.REACT_APP_URL}/netoff/form/fields?payload=${encodedPayload}`,
      {
        method: "GET",
        headers: { "api-token": api_token },
      }
    )
      .then((res) => res.json())
      .then(({ net_off_details, net_off_summary }) => {
        const allLoans = net_off_details.map((loan) => ({
          loan_id: loan.loan_id,
          loan_documentation_id: loan.loan_documentation_id,

          // Display values
          p_bal: loan.components.principal_balance,
          int_due: loan.components.interest_due,
          ovdChanges: loan.components.overdue_charge,
          bounceCharges: loan.components.bounce_charge,
          advanceAmount: loan.components.advance_amount,
          netOffAmount: loan.components.netoff_amount,

          // Store originals for comparison in updates
          originalIntDue: loan.components.interest_due,
          originalOvdCharges: loan.components.overdue_charge,
          originalAdvanceAmount: loan.components.advance_amount,
        }));

        this.setState({
          netoffData: allLoans,
          netoffSummary: {
            p_bal: parseFloat(net_off_summary.principal_balance),
            int_due: parseFloat(net_off_summary.interest_due),
            ovdChanges: parseFloat(net_off_summary.overdue_charge),
            bounceCharges: parseFloat(net_off_summary.bounce_charge),
            advanceAmount: parseFloat(net_off_summary.advance_amount),
            netOffAmount: parseFloat(net_off_summary.netoff_amount),
          },
          isSpin: false,
        });
      })
      .catch((error) => console.log("error", error));
  }

  saveCMSData(e) {
    e.preventDefault();
    this.setState({ isSpin: true });

    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    const uid = localStorage.getItem("in_userid");

    const { loan_documentation_id, netoffRemark, netoffSummary } = this.state;

    const formdata = new FormData();
    formdata.append("loan_documentation_id", loan_documentation_id);
    formdata.append("principal_balance", netoffSummary.p_bal);
    formdata.append("interest_due", netoffSummary.int_due);
    formdata.append("overdue_charge", netoffSummary.ovdChanges);
    formdata.append("bounce_charge", netoffSummary.bounceCharges);
    formdata.append("advance_amount", netoffSummary.advanceAmount);
    formdata.append("netoff_amount", netoffSummary.netOffAmount);
    formdata.append("remarks", netoffRemark || "");

    customFetch(process.env.REACT_APP_URL + "/save/netoff/data", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
            isSpin: false,
          });
        }
        return res.json();
      })
      .then((json) => {
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          this.setState({
            api_error_message: json.message,
            isErrOpen: true,
            isSpin: false,
          });
        }
        this.setState({
          api_error_message: json.message,
          isErrOpen: true,
          isSpin: false,
        });

        if (json.status == 1) {
          this.setState({
            isNetoff: false,
            netoffSummary: null,
            netoffData: [],
            netoffRemark: "",
          }, () => this.getdisbursecase());
        }
        this.forceUpdate();
      })
      .catch((error) => console.log("error", error));
  }

  handlesubmit(e) {
    e.preventDefault();
    this.setState({ isSpin: true });
    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    const uid = localStorage.getItem("in_userid");
    const formdata = new FormData();
    formdata.append("loan_documentation_id", this.state.loan_documentation_id);
    formdata.append("disbursement_date", this.state.disbdate);
    formdata.append("partner_reference_number_two", this.state.partneref);
    formdata.append("userid", uid);
    customFetch(process.env.REACT_APP_URL + "/send/disbursement/cases", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
            isSpin: false,
          });
        }
        return res.json();
      })

      .then((json) => {
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          localStorage.clear();
          this.props.history.push("/");
        }
        this.setState({
          sendcase: json.message,
          isSend: true,
          isSpin: false,
          isView: false,
          ovdChanges: "",
          bounceCharges: "",
          p_bal: "",
          int_due: "",
        });

        this.getdisbursecase();
      })
      .catch((error) => console.log("error", error));
  }

  showloandata(loan_id) {
    this.setState({ isSpin: true });
    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    // AT-2143 | AT-2179 | Ankur Makavana | 12-07-2023 | conver post method to get method
    const params = {
      loan_id: loan_id,
    };
    const queryParams = new URLSearchParams(params).toString();
    customFetch(process.env.REACT_APP_URL + "/loan/household?" + queryParams, {
      method: "GET",
      headers: { "api-token": api_token },
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
            isSpin: false,
          });
        }
        return res.json();
      })

      .then((json) => {
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          localStorage.clear();
          this.props.history.push("/");
        }
        this.setState({
          loan_detail: json,
          isLoandetail: true,
          isSpin: false,
        });
      })
      .catch((error) => console.log("error", error));
  }

  updateNetoffField = (index, field, value) => {
    if (value < 0) return;
    const updatedLoans = [...this.state.netoffData];
    updatedLoans[index][field] = value;

    this.setState({ netoffData: updatedLoans }, () => {
      this.debouncedUpdateNetoffAPI.cancel();
      this.debouncedUpdateNetoffAPI();
    });
  };

  updateAdvanceAmount = (index, newValue) => {
    if (newValue < 0) return;
    const updatedLoans = [...this.state.netoffData];
    const loan = updatedLoans[index];

    const oldVal = parseFloat(loan.originalAdvanceAmount);
    const newVal = parseFloat(newValue);

    if (!isNaN(oldVal) && newVal > oldVal) {
      alert("Advance Amount can only be decreased from the original value.");
      return;
    }

    loan.advanceAmount = newValue;
    updatedLoans[index] = loan;

    this.setState({ netoffData: updatedLoans }, () => {
      this.debouncedUpdateNetoffAPI.cancel();
      this.debouncedUpdateNetoffAPI();
    });
  };

  callNetoffAPI = async () => {
    this.isAPICalling = true;
    this.setState({ isSyncing: true });

    const { netoffData, loan_documentation_id } = this.state;

    const adjustments = [];

    for (const loan of netoffData) {
      const adjusted = {};
      if (loan.int_due !== loan.originalIntDue)
        adjusted.interest_due = parseFloat(loan.int_due) || 0;
      if (loan.ovdChanges !== loan.originalOvdCharges)
        adjusted.overdue_charge = parseFloat(loan.ovdChanges) || 0;
      if (loan.advanceAmount !== loan.originalAdvanceAmount)
        adjusted.advance_amount = parseFloat(loan.advanceAmount) || 0;

      if (Object.keys(adjusted).length > 0) {
        adjustments.push({
          loan_id: loan.loan_id,
          loan_documentation_id: loan.loan_documentation_id,
          adjusted_components: adjusted,
        });
      }
    }

    const payload = {
      loan_documentation_id,
      adjustments,
    };

    try {
      const { api_token } =
        (this.props.location && this.props.location.state) || {};

      const urlParams = new URLSearchParams({
        payload: Buffer.from(JSON.stringify(payload)).toString("base64"),
      });

      const response = await customFetch(
        process.env.REACT_APP_URL +
          "/netoff/form/fields?" +
          urlParams.toString(),
        {
          method: "GET",
          headers: { "api-token": api_token },
        }
      );
      const { net_off_details, net_off_summary } = await response.json();

      const mergedLoans = this.state.netoffData.map((loan) => {
        const updatedLoan = net_off_details.find(
          (item) => item.loan_id === loan.loan_id
        );
        if (!updatedLoan) return loan;

        return {
          ...loan,
          p_bal: updatedLoan.components.principal_balance,
          netOffAmount: updatedLoan.components.netoff_amount,
          bounceCharges: updatedLoan.components.bounce_charge,

          // Merge only if not changed again by user
          int_due:
            loan.int_due === loan.originalIntDue
              ? updatedLoan.components.interest_due
              : loan.int_due,
          ovdChanges:
            loan.ovdChanges === loan.originalOvdCharges
              ? updatedLoan.components.overdue_charge
              : loan.ovdChanges,
          advanceAmount:
            loan.advanceAmount === loan.originalAdvanceAmount
              ? updatedLoan.components.advance_amount
              : loan.advanceAmount,
        };
      });

      this.setState({
        netoffData: mergedLoans,
        netoffSummary: {
          p_bal: parseFloat(net_off_summary.principal_balance),
          int_due: parseFloat(net_off_summary.interest_due),
          ovdChanges: parseFloat(net_off_summary.overdue_charge),
          bounceCharges: parseFloat(net_off_summary.bounce_charge),
          advanceAmount: parseFloat(net_off_summary.advance_amount),
          netOffAmount: parseFloat(net_off_summary.netoff_amount),
        },
        isSyncing: false,
        lastSyncedAt: new Date(),
      });
    } catch (error) {
      console.error("Netoff API call failed", error);
    } finally {
      this.isAPICalling = false;

      if (this.isDirtyDuringCall) {
        this.isDirtyDuringCall = false;
        this.callNetoffAPI(); // Trigger another sync for latest changes
      }
    }
  };

  filterdata() {
    this.state.sort_data = [];
    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    if (this.state.searchid) {
      this.setState({ isSpin: true });

      // const formdata = new FormData();
      // formdata.append("loan_id", this.state.searchid);
      // AT-2143 | AT-2179 | Ankur Makavana | 12-07-2023 | conver post method to get method
      customFetch(
        process.env.REACT_APP_URL +
          "/get/disbursement/cases?loan_id=" +
          this.state.searchid,
        {
          method: "GET",
          headers: { "api-token": api_token },
          //body: formdata,
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((json) => {
          console.log(json);
          if (
            json.api_code === 4 ||
            json.api_code === 3 ||
            json.api_code === 5
          ) {
            localStorage.clear();
            this.props.history.push("/");
          }
          this.setState({
            disbdata: json,
            disbdata_bkp: json,
            isSpin: false,
          });
        })
        .catch((error) => console.log("error", error));
    } else {
      this.setState({ isSpin: true });

      //const formdata = new FormData();
      // AT-2143 | AT-2179 | Ankur Makavana | 12-07-2023 | conver post method to get method
      customFetch(process.env.REACT_APP_URL + "/get/disbursement/cases", {
        method: "GET",
        headers: { "api-token": api_token },
      })
        .then((res) => {
          return res.json();
        })
        .then((json) => {
          if (
            json.api_code === 4 ||
            json.api_code === 3 ||
            json.api_code === 5
          ) {
            localStorage.clear();
            this.props.history.push("/");
          }
          this.setState({
            disbdata: json,
            disbdata_bkp: json,
            isSpin: false,
          });
        })
        .catch((error) => console.log("error", error));
    }
  }
  render() {
    const {
      disbdata,
      isView,
      loan_id,
      partneref,
      isErrOpen,
      api_error_message,
      sendcase,
      isSend,
      loan_detail,
      isLoandetail,
      isNetoff,
    } = this.state;
    const enabled = this.state.disbdate !== "" && this.state.partneref !== "";
    return (
      <>
        {this.state.isSpin ? (
          <div className="preloader">
            <div className="loader" ng-hide="data.length > 0"></div>
          </div>
        ) : (
          ""
        )}
        <div
          className={
            isErrOpen
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          style={isErrOpen ? { zIndex: 1061 } : {}}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={isNetoff ? this.closeErrPopup : this.loadDisburseCase}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>{api_error_message}</p>
            </div>
          </div>
        </div>
        <div
          className={
            isLoandetail
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isLoandetail: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div>
                {loan_detail.map((loandata) => {
                  return (
                    <>
                      <div className="loanid-holder text-center">
                        <span>{loandata.name_as_per_account}</span>
                      </div>
                      <div className="loan-dataholder">
                        <div className="border-b2">
                          HH No : {loandata.household_number}
                        </div>
                        <div>Branch : {loandata.branch_name}</div>
                      </div>

                      <div className="loan-dataholder">
                        <div className="border-b2">
                          Bank Name : {loandata.bank_name}
                        </div>
                        <div className="border-b2">
                          Account No : {loandata.account_number}
                        </div>
                        <div className="border-b2">
                          Account Type : {loandata.account_type_name}
                        </div>
                        <div>IFSC : {loandata.ifsc}</div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            isSend
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isSend: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>{sendcase}</p>
            </div>
          </div>
        </div>
        <div
          className={
            isView
              ? "modal fade show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="0"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
          autoFocus={false}
          ref={this.modalRef}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isView: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <form onSubmit={this.handlesubmit}>
                <div className="loanid-holder text-center">
                  <span>Loan ID : {loan_id}</span>
                </div>
                <div className="selnach-holder">
                  <div className="row">
                    <div className="form-group col-6">
                      <label for="inputEmail4">Disbursement Date</label>
                      <input
                        type="date"
                        id="date_select"
                        className="form-control"
                        tabIndex="0"
                        autoFocus={true}
                        value={this.state.disbdate}
                        min={`${
                          new Date(
                            moment()
                              .subtract(1, "months")
                              .format("YYYY-MM-DD")
                          )
                            .toISOString()
                            .split("T")[0]
                        }`}
                        onChange={(e) =>
                          this.setState({ disbdate: e.target.value })
                        }
                        name="disbdate"
                        placeholder="Disbursement Date"
                      />
                    </div>
                    <div className="form-group col-6">
                      <label for="inputPassword4">Partner Ref#</label>
                      <input
                        className="form-control"
                        id="inputPassword4"
                        placeholder="Partner Reference Number"
                        value={this.state.partneref}
                        tabIndex="0"
                        onChange={(e) =>
                          this.setState({ partneref: e.target.value })
                        }
                        name="partneref"
                      />
                    </div>
                    <div className="col-12 text-center">
                      <input
                        type="submit"
                        tabIndex="0"
                        value="submit"
                        className="btn btn-outline-primary"
                        disabled={!enabled}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div
          className={
            isNetoff
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isNetoff: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <form onSubmit={this.saveCMSData}>
                <div className="loanid-holder text-center">
                  <span>Loan ID : {loan_id}</span>
                  <br />
                  <span>Netoff / Forclosure Loan ID:</span>
                </div>
                <div className="selnach-holder">
                  {this.state.netoffData.map((loan, index) => (
                    <div key={index} className="loan-block mb-4">
                      <div className="row mb-2">
                        <div className="col-12">
                          <label>
                            <strong>Loan ID: {loan.loan_id}</strong>
                          </label>
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-3">
                          <label htmlFor={`intDue-${index}`}>
                            <strong>Principal Balance</strong>
                          </label>
                          <input
                            className="form-control"
                            placeholder="Principal Balance"
                            type="number"
                            min={0}
                            value={loan.p_bal}
                            readOnly
                          />
                        </div>
                        <div className="form-group col-3">
                          <label htmlFor={`intDue-${index}`}>
                            <strong>Interest Due</strong>
                          </label>
                          <input
                            id={`intDue-${index}`}
                            className="form-control"
                            placeholder="Interest Due"
                            value={loan.int_due}
                            type="number"
                            min={0}
                            onChange={(e) =>
                              this.updateNetoffField(
                                index,
                                "int_due",
                                e.target.value
                              )
                            }
                            required
                          />
                        </div>
                        <div className="form-group col-3">
                          <label htmlFor={`intDue-${index}`}>
                            <strong>Overdue Charges</strong>
                          </label>
                          <input
                            className="form-control"
                            placeholder="Overdue Charges"
                            value={loan.ovdChanges}
                            type="number"
                            min={0}
                            onChange={(e) =>
                              this.updateNetoffField(
                                index,
                                "ovdChanges",
                                e.target.value
                              )
                            }
                            required
                          />
                        </div>
                        <div className="form-group col-3">
                          <label htmlFor={`intDue-${index}`}>
                            <strong>Bounce Charges</strong>
                          </label>
                          <input
                            className="form-control"
                            placeholder="Bounce Charges"
                            type="number"
                            min={0}
                            value={loan.bounceCharges}
                            readOnly
                          />
                        </div>
                        <div className="form-group col-3">
                          <label htmlFor={`intDue-${index}`}>
                            <strong>Advance Amount</strong>
                          </label>
                          <input
                            className="form-control"
                            placeholder="Advance Amount"
                            type="number"
                            min={0}
                            value={loan.advanceAmount}
                            onChange={(e) =>
                              this.updateAdvanceAmount(index, e.target.value)
                            }
                            max={loan.originalAdvanceAmount}
                            required
                          />
                        </div>
                        <div className="form-group col-3">
                          <label htmlFor={`intDue-${index}`}>
                            <strong>Net-off Amount</strong>
                          </label>
                          <input
                            className="form-control"
                            placeholder="Net-Off Amount"
                            type="number"
                            min={0}
                            value={loan.netOffAmount}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Summary section */}
                  {this.state.netoffSummary && (
                    <div className="row mt-4">
                      <div className="col-12">
                        <h5>
                          <strong>Netoff Summary</strong>
                        </h5>
                        <div className="row">
                          <div className="col-md-4 col-sm-6 mb-2">
                            <strong>Principal Balance:</strong>{" "}
                            {this.state.netoffSummary.p_bal.toFixed(2)}
                          </div>
                          <div className="col-md-4 col-sm-6 mb-2">
                            <strong>Interest Due:</strong>{" "}
                            {this.state.netoffSummary.int_due.toFixed(2)}
                          </div>
                          <div className="col-md-4 col-sm-6 mb-2">
                            <strong>Overdue Charges:</strong>{" "}
                            {this.state.netoffSummary.ovdChanges.toFixed(2)}
                          </div>
                          <div className="col-md-4 col-sm-6 mb-2">
                            <strong>Bounce Charges:</strong>{" "}
                            {this.state.netoffSummary.bounceCharges.toFixed(2)}
                          </div>
                          <div className="col-md-4 col-sm-6 mb-2">
                            <strong>Advance Amount:</strong>{" "}
                            {this.state.netoffSummary.advanceAmount.toFixed(2)}
                          </div>
                          <div className="col-md-4 col-sm-6 mb-2">
                            <strong>Net-Off Amount:</strong>{" "}
                            {this.state.netoffSummary.netOffAmount.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Syncing Section */}
                  <div className="row mt-3">
                    <div className="col-md-6 col-sm-12 mb-2">
                      {this.state.isSyncing ? (
                        <span className="text-info">
                          <i className="fa fa-refresh fa-spin mr-1" /> Syncing
                          latest values...
                        </span>
                      ) : this.state.lastSyncedAt ? (
                        <span className="text-muted">
                          Last synced at:{" "}
                          {new Date(this.state.lastSyncedAt).toLocaleTimeString(
                            "en-IN",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            }
                          )}
                        </span>
                      ) : (
                        <span className="text-muted">Not synced yet</span>
                      )}
                    </div>
                  </div>

                  {/* Remark section */}
                  <div className="row mt-3">
                    <div className="col-12">
                      <label>
                        <strong>
                          Remarks (mandatory if Advance or Interest is edited):
                        </strong>
                      </label>
                      <textarea
                        className="form-control"
                        value={this.state.netoffRemark}
                        onChange={(e) =>
                          this.setState({ netoffRemark: e.target.value })
                        }
                        placeholder="Enter remarks..."
                        rows="3"
                      />
                    </div>
                  </div>

                  {/* Submit button */}
                  <div className="row">
                    <div className="col-12 text-center">
                      <input
                        type="submit"
                        value="submit"
                        className="btn btn-outline-primary"
                        disabled = {this.state.isSyncing}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <section className="main-sec">
          <div className="container fix-width">
            <div className="header-area">
              <div
                className="icon_bg"
                onClick={() => this.props.history.goBack()}
              >
                <img
                  src={require("../assets/images/back.png")}
                  className="netoff_icon_img"
                  alt=""
                />
              </div>
              <div className="head-title">Disburse</div>
              <div className="log-out-report">
                <img
                  src={require("../assets/images/power-off.png")}
                  onClick={() => logout()}
                  alt=""
                />
              </div>
            </div>
            <div className="mt-3">
              <div className="search-area">
                <div className="row">
                  <div className="col-md-8">
                    <input
                      name="searchid"
                      className="form-control"
                      placeholder="search here..."
                      onChange={(e) => {
                        this.setState({ searchid: e.target.value });
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-primary"
                      onClick={() => this.filterdata()}
                    >
                      search
                    </button>
                  </div>
                </div>
              </div>
              {disbdata.length > 0
                ? disbdata.map((item, index) => (
                    <div className="card-holder-disb mt-3" key={index}>
                      <div className="card-name-holder">
                        <div className="row">
                          <div className="col-10">
                            <div className="card-name">Loan ID :</div>
                            <div
                              className="card-hhid"
                              onClick={() => this.showloandata(item.loan_id)}
                            >
                              <span className="loan_data">{item.loan_id}</span>
                            </div>
                          </div>
                          <div className="col-2">
                            <span className="card-status">
                              <div>
                                {/* <button
                                  className="btn btn-primary"
                                  onClick={() =>
                                    this.showpopup(
                                      item.loan_id,
                                      item.loan_documentation_id
                                    )
                                  }
                                >
                                  add
                                </button> */}
                                {item.flag == 0 ? (
                                  <img
                                    src={require("../assets/images/plus.png")}
                                    className="netoff_icon_img loan_data"
                                    alt=""
                                    tabIndex="0"
                                    onClick={() =>
                                      this.showpopup(
                                        item.loan_id,
                                        item.loan_documentation_id
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (e.code === "Enter") {
                                        this.showpopup(
                                          item.loan_id,
                                          item.loan_documentation_id
                                        );
                                      }
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={require("../assets/images/net-off.png")}
                                    className="netoff_icon_img loan_data"
                                    alt=""
                                    onClick={() =>
                                      this.netOffPopup(
                                        item.loan_id,
                                        item.ref_loan_doc_id,
                                        item.loan_documentation_id
                                      )
                                    }
                                  />
                                )}
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </section>
        <ChatSupportBtn history={this.props.history} />
      </>
    );
  }
}

export default withRouter(Disbursement);
